import {
  USER_BOOK,
  BOOK_INDEX,
  UNIT_DETAIL,
  SECTION_LIST,
  RESULTS,
  CURRENT_SECTION,
  LINKED_UNIT_DETAIL,
} from '../actions/BookActions'
// Import translates
import i18n, { defaultLocale, unicodeToIsoMap } from '../i18n'

export function bookReducer(state = null, action) {
  // implement Locales.
  let locale = defaultLocale

  if (state && state.book && state.book.locale) {
    const bookFullLocale = state.book.locale
    locale = unicodeToIsoMap[bookFullLocale]
  } else if (state && state.userBook && state.userBook.book && state.userBook.book.language) {
    locale = state.userBook.book.language
  }

  try {
    i18n.init({ lng: locale })
  } catch (error) {
    console.error('BookReducer', error)
  }

  switch (action.type) {
    case USER_BOOK:
      return action.payload
    default:
      return state
  }
}
export function bookIndex(state = null, action) {
  switch (action.type) {
    case BOOK_INDEX:
      return action.payload
    default:
      return state
  }
}
export function unitDetail(state = null, action) {
  switch (action.type) {
    case UNIT_DETAIL:
      return action.payload
    default:
      return state
  }
}
export function linkedUnitDetail(state = null, action) {
  switch (action.type) {
    case LINKED_UNIT_DETAIL:
      return action.payload
    default:
      return state
  }
}
export function sectionList(state = null, action) {
  switch (action.type) {
    case SECTION_LIST:
      return action.payload
    default:
      return state
  }
}
export function results(state = null, action) {
  switch (action.type) {
    case RESULTS:
      return action.payload
    default:
      return state
  }
}
export function currentSection(state = null, action) {
  switch (action.type) {
    case CURRENT_SECTION:
      return action.payload
    default:
      return state
  }
}
